module.exports = "<form class=\"sidebar-form\">\n  <div class=\"form-group p-2 mb-0\">\n    <input type=\"text\" class=\"form-control\" aria-describedby=\"search\" placeholder=\"Search...\">\n  </div>\n</form>\n"


//////////////////
// WEBPACK FOOTER
// /opt/sss_web/sss_web/src/app/components/app-sidebar-form/app-sidebar-form.component.html
// module id = ../../../../../src/app/components/app-sidebar-form/app-sidebar-form.component.html
// module chunks = main